
export const toPercent = (x: number) => (x * 100).toFixed(2);
